import * as yup from 'yup';

export const addLinkSchema = yup.object().shape({
  text: yup.string().required('This field is required'),
  link: yup.string().url('Link is not valid').required('This field is required'),
});

export const addNewQuickAnswerSchema = yup.object().shape({
  title: yup.string().required('This field is required'),
  content: yup.string().required('This field is required'),
});
